import api from '../configs/api';
const OrganisationServices = {
    organisations: (pageNumber: number) =>
        api.get('organisations', { params: { subscription: true, suspended: false, page: pageNumber, size: 10 } }),
    //TODO: isMonthly should be conditional
    createOrganisation: (newOrganisation: any) => api.post('organisations', { ...newOrganisation, isMonthly: true }),
    createOrganizationUser: (organizationId: number, newUser: any) => {
        //TODO: isMonthly should be conditional
        newUser = { ...newUser, isMonthly: true };
        var formData = new FormData();

        for (let key in newUser) {
            formData.append(key, newUser[key]);
        }
        return api.post(`organisations/${organizationId}/users?is_admin=true`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    },
    getOrganisation: (id: number) => api.get(`organisations/${id}`),
    updateOrganisation: (id: number, organisation: any) => api.put(`organisations/${id}`, organisation),
    deleteOrganisation: (id: number) => api.delete(`/organisations/${id}`),
    getSubscriptions: (type: string) => api.get('subscriptions', { params: { type: type } }),
    suspend: (id: number, state: Boolean) => api.put(`organisations/${id}/suspend?state=${state}`)
};

export default OrganisationServices;
